var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-skeleton-loader',{attrs:{"type":"paragraph"}}),_c('v-skeleton-loader',{staticClass:"my-6",attrs:{"type":"paragraph"}}),_c('v-skeleton-loader',{attrs:{"type":"paragraph"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }